import { HAS_COMPLETED_ONBOARDING_SLIDESHOW } from '../constants';
import { useEffect, useCallback, useState } from 'react';

export function useHasCompletedOnboardingSlideshow() {
  const [hasCompletedOnboardingSlideshow, setHasCompletedOnboardingSlideshow] = useState(false);

  useEffect(() => {
    const stored_result = localStorage.getItem(HAS_COMPLETED_ONBOARDING_SLIDESHOW);
    setHasCompletedOnboardingSlideshow(!!stored_result);
  }, []);

  const markAsCompleted = useCallback(() => {
    localStorage.setItem(HAS_COMPLETED_ONBOARDING_SLIDESHOW, 'true');
    setHasCompletedOnboardingSlideshow(true);
  }, []);

  return { hasCompletedOnboardingSlideshow, markAsCompleted };
}
